import { Button as BaseButton } from '@base-ui/react/button'

import { useHydrated } from '@/hooks/use-hydrated'

/**
 * An UNSTYLED `<button>` that is inert until hydration. Under full SSR a click landing before React binds the
 * handler is silently dropped (Playwright's documented SSR flake class); `useHydrated()` is false on the server
 * AND on the first client render, so the markup matches and the gate clears in the commit that attaches the
 * handler. Deliberately the NATIVE `disabled` attribute — base-ui's `focusableWhenDisabled` renders
 * `aria-disabled`, which Playwright's actionability wait does not key on. app.css redefines the `disabled:`
 * variant as `&:disabled:not([data-hydrating])`, so this window greys nothing.
 */
export function ButtonPrimitive({ disabled, ...props }: BaseButton.Props) {
  const hydrated = useHydrated()
  return (
    <BaseButton
      disabled={disabled || !hydrated}
      // "Inert only until hydration" — app.css keys the `disabled:` variant off its absence.
      data-hydrating={!hydrated && !disabled ? '' : undefined}
      {...props}
    />
  )
}
